import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';
import {SessionService} from '../../../core/service/session.service';
import {EventService} from '../../../core/service/event.service';
import {CsvService} from '../../../core/service/csv.service';
import {SHIYOULOT_KEY_SUFFIX, TAISOKU_CSV_FORMAT, TAISOKU_CV, TAISOKU_MHI} from '../../constants';
import {AngularFireFunctions} from '@angular/fire/functions';
import {MasterService} from '../../../core/service/master.service';
import {SendTaisokuAlertRequest} from '../../interfaces/alert';
import {exceptKeyWithOptional, yyyyMMdd} from '../../typeAliases';
import {TaisokuJisshiNaiyou} from '../../interfaces/taisoku-jisshi-naiyou';
import {TaisokuEvent} from '../../interfaces/taisoku-event';
import {KeishaService} from "../../../core/service/keisha.service";
import {KeishaConfig} from "../../interfaces/keisha";
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'app-taisoku-event-dialog',
  templateUrl: './taisoku-event-dialog.component.html',
  styleUrls: ['./taisoku-event-dialog.component.scss',
    './../../layout/layout.component.scss']
})
export class TaisokuEventDialogComponent implements OnInit {
  @ViewChild('fileInput') fileInput: any;
  file: File | null = null;
  selectedMeisais: TaisokuEvent[] = [];
  inputForm: exceptKeyWithOptional<TaisokuJisshiNaiyou, 'jisshiDate'> = this.getInitialTaisokuJisshiNaiyou();
  editEvent = false;
  selectedLotIndex: number | null = null;
  edukeDate: yyyyMMdd;
  readonly ROW_DELIMITER = 0.020;
  constructor(@Inject(MAT_DIALOG_DATA) public data: TaisokuEvent[],
              public matDialogRef: MatDialogRef<TaisokuEventDialogComponent>,
              public commonService: CommonService,
              public sessionService: SessionService,
              public eventService: EventService,
              public csvService: CsvService,
              private afn: AngularFireFunctions,
              private masterService: MasterService,
              private keishaService: KeishaService) {
    this.edukeDate = this.data[0].taishouEdukeDate;
  }

  /**
   *
   */
  ngOnInit(): void {
    this.selectedMeisais = this.data;
    this.eventService.setInputForm2(this.inputForm, this.selectedMeisais[0]);
    this.eventService.updateJisshiNichirei2(this.inputForm, this.edukeDate);
    if (this.selectedMeisais[0].id) {
      this.selectedLotIndex = this.csvService.getSelectedIndex(this.selectedMeisais[0].id);
    }
  }

  /**
   * 体測データ登録
   */
  register() {
    // csv登録しない場合でも、登録可能にするため、バリデーションを緩和する。
    // if (this.selectedLotIndex === null) {
    //   alert('体測データが選択されていません。');
    //   return;
    // }
    if (!this.commonService.isNumeric(this.inputForm.mean)) {
      alert('平均体重(g)に数値を入力してください。');
      return;
    }
    if (!this.commonService.isNumeric(this.inputForm.cv)) {
      alert('CVに数値を入力してください。');
      return;
    }
    // 選択した体測イベントに対して、共通項目を書き込む。
    this.selectedMeisais.forEach((meisai: TaisokuEvent) => {
      this.inputForm.mean = Number(this.inputForm.mean);
      this.inputForm.cv = Number(this.inputForm.cv);
      this.eventService.inputForm2Event2(this.inputForm, meisai);
    });
    // 体測イベントを更新する。
    this.eventService.updateEvents(this.selectedMeisais)
      .then(async() => {
        // 基本的にはないが、登録されたイベント毎に飼養ロットkeyがない場合、エラーを投げる。
        // 登録されたイベント全て対して、アラートチェックを行い、その中で飼養ロットkeyがないものは最後にまとめて
        // エラーを投げる。

        // 飼養ロットkeyがない体測イベント明細リスト
        const taisokuEventsWithNoShiyoulot: TaisokuEvent[] = [];
        // 選択された体測イベントの飼養ロットに対してアラートを送信する
        for (const selectedMeisai of this.selectedMeisais) {
          const shiyoulotKey = selectedMeisai.eventTaishouIds.find((val: string) => {
            return val.endsWith(SHIYOULOT_KEY_SUFFIX);
          });
          if (!shiyoulotKey) {
            // 飼養ロットkeyがない体測イベント明細
            taisokuEventsWithNoShiyoulot.push(selectedMeisai);
            continue;
          }
          const shiyoulotId = shiyoulotKey ? shiyoulotKey.slice(0, -2) : '';
          const alertArray: SendTaisokuAlertRequest[] = [];
          const keishaConfig = (await firstValueFrom(this.keishaService.genKeishaConfigRef(this.selectedMeisais[0].taishouKeisha).get())).data() as KeishaConfig;
          this.sendAlertTaisokuMhi(shiyoulotId, alertArray, keishaConfig);
          this.sendAlertTaisokuCV(shiyoulotId, alertArray, keishaConfig);
          if (alertArray.length > 0) {
            // Functionsを起動
            firstValueFrom(this.afn.httpsCallable('notification-sendNotification-sendTaisokuAlert')(alertArray)).then();
          }
        }
        // 飼養ロットkeyがない体測イベント明細がある場合、エラーを投げる
        if (!!taisokuEventsWithNoShiyoulot.length) {
          const taisokuEventsWithNoShiyoulotNames = taisokuEventsWithNoShiyoulot.map((val: TaisokuEvent) => val.taishouLotName).join(', ');
          throw new Error('イベントに飼養ロットが登録されていません。' + taisokuEventsWithNoShiyoulotNames);
        }
      }).then(() => {
      // 成功した場合のみ true を返す
        this.commonService.onClick(this.matDialogRef, true);
      }).catch(e => {
        console.log(e);
        alert(e);
      });
  }

  /**
   *
   * @param shiyoulotId
   * @param alertArray
   * @private
   */
  private sendAlertTaisokuCV(shiyoulotId: string, alertArray: SendTaisokuAlertRequest[], keishaConfig: KeishaConfig) {
    // TODO Alart型適用
    const cvShikiiChiRow = keishaConfig.alertProgram.find(row => {
      return row.shubetsu === TAISOKU_CV && row.isValid;
    });
    if (!cvShikiiChiRow) { return; }
    const cvShikiiChi = cvShikiiChiRow.shikiiChi;
    if (this.inputForm.cv && this.inputForm.cv >= cvShikiiChi) {
      const alertObj: SendTaisokuAlertRequest = {
        id: this.selectedMeisais[0].id + this.selectedMeisais[0].yoteiDate + 'CV',
        date: this.inputForm.jisshiDate ?? this.commonService.getDateWithString(),
        timeStamp: new Date(),
        operator: this.inputForm.jisshiSha ?? this.sessionService.session.personalSetting.name,
        shiyoulotId: shiyoulotId,
        shiyoulotName: this.selectedMeisais[0].taishouLotName,
        keishaId: this.selectedMeisais[0].taishouKeisha,
        farmId: this.commonService.getName(this.masterService.keishaMaster, this.selectedMeisais[0].taishouKeisha, 'farmId'),
        shubetsu: TAISOKU_CV,
        taishouKeys: [{cv: this.inputForm.cv}],
        alertAbstract: '体測CV :' + this.inputForm.cv,
        kakuninDate: '',
        kakuninOperator: '',
        kakuninComment: ''
      };
      alertArray.push(alertObj);
    }
  }

  /**
   *
   * @param shiyoulotId
   * @param alertArray
   */
  private sendAlertTaisokuMhi(shiyoulotId: string, alertArray: SendTaisokuAlertRequest[], keishaConfig: KeishaConfig) {
    const meanShikiiChiRow = keishaConfig.alertProgram.find(row => {
      return row.shubetsu === 'taisokuMhi' && row.isValid;
    });
    if (!meanShikiiChiRow) { return; }
    const meanShikiiChi = meanShikiiChiRow.shikiiChi;
    const keishuData = this.masterService.keishuMaster.find(keishu => {
      return keishu.id === this.selectedMeisais[0].taishouKeishu;
    });
    if (!keishuData) { return; }
    const manualwWeights = keishuData.weights;
    const taisokuWeekNumber = this.selectedMeisais[0].eventName.match(/[0-9]+/i) ?? ['0'];
    const week = this.commonService.genWNN(Number(taisokuWeekNumber[0]));
    const manual = manualwWeights[week];
    if (this.inputForm.mean && (this.inputForm.mean * 100 >= manual * (100 + meanShikiiChi)
      || this.inputForm.mean * 100 <= manual * (100 - meanShikiiChi))) {
      const alertObj: SendTaisokuAlertRequest = {
        id: this.selectedMeisais[0].id + this.selectedMeisais[0].yoteiDate + 'Mhi',
        date: this.inputForm.jisshiDate ?? this.commonService.getDateWithString(),
        timeStamp: new Date(),
        operator: this.inputForm.jisshiSha ?? this.sessionService.session.personalSetting.name,
        shiyoulotId: shiyoulotId,
        shiyoulotName: this.selectedMeisais[0].taishouLotName,
        keishaId: this.selectedMeisais[0].taishouKeisha,
        farmId: this.commonService.getName(this.masterService.keishaMaster, this.selectedMeisais[0].taishouKeisha, 'farmId'),
        shubetsu: TAISOKU_MHI,
        taishouKeys: [{mean: this.inputForm.mean}],
        alertAbstract: '体測M比 :' + this.inputForm.mean + 'g',
        kakuninDate: '',
        kakuninOperator: '',
        kakuninComment: ''
      };
      alertArray.push(alertObj);
    }
  }

  /**
   * 体側イベント取り消し
   */
  undo() {
    if (confirm('実施内容を取り消しますか?')) {
      this.eventService.undoEvents(this.selectedMeisais).then(() => {
        this.commonService.onClick(this.matDialogRef, true);
      }).catch();
    }
  }

  /**
   * 体側イベント削除
   */
  delete() {
    if (confirm('作業を削除しますか?')) {
      this.eventService.deleteEvents(this.selectedMeisais).then(() => {
        this.commonService.onClick(this.matDialogRef, true);
      }).catch();
    }
  }

  // ファイル選択
  /**
   *
   */
  onClickFileInputButton(): void {
    this.fileInput.nativeElement.click();
  }

  /**
   *
   */
  async onChangeFileInput() {
    this.file = this.fileInput.nativeElement.files[0];
    console.log(this.file);
    this.fileInput.nativeElement.value = '';
    this.selectedLotIndex = null;
    if (this.file) {
      this.csvService.csvData = await this.csvService.csvJSON(this.file, TAISOKU_CSV_FORMAT);
      console.log(this.csvService.csvData);
      this.csvService.separatedCsvData = [];
      let tempRows: any = [];
      this.csvService.csvData.forEach((row: any, index: number) => {
        if (row.weight && row.weight > this.ROW_DELIMITER) {
          tempRows.push(row);
        } else {
          this.csvService.separatedCsvData.push({relatedLot: '', relatedLotEventId: '', csv: tempRows});
          tempRows = [];
        }
        if (index + 1 === this.csvService.csvData.length) {
          this.csvService.separatedCsvData.push({relatedLot: '', relatedLotEventId: '', csv: tempRows});
          tempRows = [];
        }
      });
      console.log(this.csvService.separatedCsvData);
    }
  }

  /**
   *
   * @param lotIndex
   */
  lotSelected(lotIndex: number) {
    this.selectedLotIndex = lotIndex;
    console.log(this.selectedLotIndex);
    this.preSave();
  }

  /**
   * inputFormに卵重データを詰める。
   */
  preSave() {
    if (this.selectedLotIndex === null) {
      return;
    }
    const selectedLot = this.csvService.separatedCsvData[this.selectedLotIndex];
    selectedLot.relatedLot = this.selectedMeisais.map(e => e.taishouLotName).join(', ');
    selectedLot.relatedLotEventId = this.selectedMeisais[0].id;
    // idの配列を作成
    selectedLot.relatedLotEventIdList = this.selectedMeisais.map(e => e.id);
    // kg → g　に単位を変換。
    const weights = selectedLot.csv.map((e: any) => Math.round(e.weight * 1000 * 10) / 10);

    const mean = this.commonService.calcMean(weights);
    const standardDeviation = this.commonService.calcStandardDeviation(weights, mean);
    // %表示にするために100倍する。
    const cv = Math.round(standardDeviation / mean * 10000) / 100;

    this.inputForm.weights = weights;
    this.inputForm.mean = mean;
    this.inputForm.cv = cv;
  }

  /**
   *
   */
  getInitialTaisokuJisshiNaiyou(): exceptKeyWithOptional<TaisokuJisshiNaiyou, 'jisshiDate'> {
    return {
      jisshiSha: this.sessionService.session.personalSetting.name,
      jisshiDate: this.commonService.getDateWithString(),
      jisshiNichirei: undefined,
      cv: undefined,
      mean: undefined,
      weights: undefined
    };
  }
}
